module.exports = __webpack_public_path__ + "static/img/4559_phase_function_Paper_Points.ec5aa5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4559_phase_function_Paper_Points.png
// module id = 64qA
// module chunks = 0